import {
  Alert,
  Button,
  Collapse,
  LinearProgress,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useConfirmation } from '../../context/ConfirmationContext';
import { FullScreenDialog } from '../../core/FullScreenDialog';
import { LoadingDialog } from '../../core/LoadingDialog';
import { uploadFetch, useFetch } from '../../hooks/useFetch';
import { ILanguageSectionFullObject } from '../../Interfaces/ILanguageSection';
import { LanguageSectionEdit } from './LanguageSectionEdit';

interface IProps {
  idLanguageSection: number;
  setIdLanguageSection: Function;
}

export const LanguageSectionWrapper: React.FC<IProps> = props => {
  const { showConfirmation } = useConfirmation();
  const [
    languageSectionFullObject,
    setLanguageSectionFullObject,
    wasSuccessfully,
  ] = useFetch<ILanguageSectionFullObject>(
    '/languagesection/fullObject/',
    props.idLanguageSection
  );

  const [isLoading, setIsLoading] = useState(false);
  const [wasSuccessfullySaved, setWasSuccessfullySaved] = useState(true);

  useEffect(() => {
    (async () => {
      if (!languageSectionFullObject && !wasSuccessfully)
        await showConfirmation({
          title: 'Fehler',
          message: 'Ein Fehler ist aufgetreten',
          confirmButtonText: 'Ok',
        });
    })();
  }, [wasSuccessfully, languageSectionFullObject]);

  const getIsDisabled = () => {
    if (languageSectionFullObject !== undefined) {
      return (
        languageSectionFullObject.LanguageEntryArray.filter(
          x => x.KeyValue === '' || x.de === '' || x.en === '' || x.fr === ''
        ).length > 0
      );
    }
  };

  const handleAfterSave = () => {
    props.setIdLanguageSection(null);
  };

  const handleSave = () => {
    if (languageSectionFullObject !== undefined) {
      const uploadObject = {
        ...languageSectionFullObject,
        isPublic: Boolean(languageSectionFullObject.isPublic),
      };
      uploadFetch(
        '/languagesection/fullObject',
        languageSectionFullObject.idLanguageSection < 0,
        uploadObject,
        handleAfterSave,
        setWasSuccessfullySaved,
        undefined,
        setIsLoading
      );
    }
  };

  if (languageSectionFullObject === undefined)
    return <LoadingDialog maxWidth='sm' />;

  return (
    <>
      <FullScreenDialog
        isOpen={true}
        onClose={() => props.setIdLanguageSection(null)}
        title='Sprackpaket/-sektion'
      >
        <>
          <Typography variant='h5'>
            Sprachpaket: {languageSectionFullObject.LanguageSection}
            <Button
              onClick={handleSave}
              disabled={getIsDisabled() || isLoading}
              variant='contained'
              sx={{ float: 'right' }}
            >
              Speichern
            </Button>
          </Typography>
          <br />
          <Collapse in={!wasSuccessfullySaved}>
            <Alert severity='error'>
              Beim Speichern ist ein Fehler aufgetretten!
            </Alert>
          </Collapse>
          <Collapse in={isLoading}>
            <LinearProgress />
          </Collapse>
          <br />
          <LanguageSectionEdit
            languageSectionFullObject={languageSectionFullObject}
            setLanguageSectionFullObject={setLanguageSectionFullObject}
          />
        </>
      </FullScreenDialog>
    </>
  );
};
